module.exports = __webpack_public_path__ + "img/haworth-projektion.de75d5b1.png";